module.exports = __webpack_public_path__ + "img/solution-farmer-img.450678c3.png";